import { useEffect, useState } from 'react';
import axios from 'axios';

const useGetCountryData = (url) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // TODO: 테스트 단계에서는 VPN 사용 시 로컬스토리지를 직접 조작해줘야 할 수 있어서 기능 제외, 테스트 이후 주석 해제
    // const storedData = localStorage.getItem('countryData');

    // if (process.env.NODE_ENV !== 'development') {
    //   // localStorage 내 해당 key, value 있으면 가져옴
    //   if (storedData) {
    //     setData(JSON.parse(storedData));
    //     return;
    //   }
    // }

    const fetchData = async () => {
      try {
        const response = await axios.get(url);
        const newData = response.data;
        setData(newData);
      } catch (error) {
        console.error('error', error);
      }
    };

    // fetchData 함수 호출
    fetchData();
  }, [url]);

  return data;
};

export default useGetCountryData;
